import {
  // ChevronUp,
  
  Edit,
  Trash2,
  // PlusCircle,
  // RotateCcw,
} from "feather-icons-react/build/IconComponents";
import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

// import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import Brand from "../../../core/modals/inventory/brand";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { all_routes } from "../../../Router/all_routes";
// import { OverlayTrigger, Tooltip } from "react-bootstrap";
// import { setToogleHeader } from "../../../core/redux/action";
import CommonMaterialReactTable from "../../MaterialReactTable/CommonMaterialReactTable";
import apiHandler from "../../common/api";
import { Box } from "@mui/material";
import "sweetalert2/dist/sweetalert2.min.css";
// import { useCheckUserPermission } from "../../common/userPermission";
import config from "../../../config";
import HeaderModule from "../../components/Header/HeaderModule";
//import config from "../../../config";

const SocialLinkList = () => {
  // const location = useLocation();
  // const parts = location.pathname;
  // let pathname = parts?.trim()?.split("/");
  // const dispatch = useDispatch();
  // const data = useSelector((state) => state.toggle_header);
  // const ID = localStorage.getItem("ID");
  const navigate = useNavigate();
  const [productlist, setProductlist] = useState([]);
  const [deletes, setdelete] = useState(false);
  const MySwal = withReactContent(Swal);

  const showConfirmationAlert = (id) => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, delete it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        showLoadingAlert(); // Show loader while deleting
        handleDelete(id);
      }
    });
  };

  const showLoadingAlert = () => {
    MySwal.fire({
      title: "Deleting...",
      text: "Please wait while we process your request.",
      allowOutsideClick: false,
      didOpen: () => {
        MySwal.showLoading(); // Show loading spinner
      },
    });
  };

  const handleDelete = async (id) => {
    let reqobj = {
      ID: id,
      Module: "SocialLinkMaster",
    };

    try {
      const response = await apiHandler({
        method: "POST",
        route: "Superadmin/deletebymoduleid",
        payload: reqobj,
      });

      if (response.ResponseCode === "SUCCESS") {
        MySwal.fire({
          title: "Deleted!",
          text: "Your file has been deleted.",
          icon: "success",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
        setdelete(!deletes);
      } else {
        MySwal.fire({
          title: "Error!",
          text: "Something went wrong. Please try again.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      MySwal.fire({
        title: "Error!",
        text: "An error occurred. Please try again later.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const columns = [
    {
      header: "ID",
      accessorKey: "ID",
      enableSorting: true,
      sortingFn: "numeric",
    },
    {
      header: "Social",
      accessorKey: "name",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "Icons",
      accessorKey: "icon",
      // enableSorting: true,
      // sortingFn: "alphanumeric", // check the icon url for  showing the icon
      Cell: ({ row }) => (
        <>
          <img
            src={config.Imageurl + row.original.icon}
            alt={row.original.name}
            style={{ width: "45px" }}
          />
        </>
      ),
    },
    {
      accessorKey: "actions",
      header: "Actions",
      enableSorting: false,
      enableColumnFilter: false,
      Cell: ({ row }) => (
        <Box sx={{ display: "flex", gap: "0.5rem" }}>
          <button
           className="btn btn-outline-primary btn-sm me-2"
            // color="primary"
            onClick={() => {
              navigate(`${route.SocialLinkMaster}/${row.original.ID}`);
              console.log("Edit row:", row.original.ID);
            }}
          >
            <Edit className='custome-icon-size' />
          </button>
          <button
           className="btn btn-outline-primary btn-sm me-2"
            // color="error"
            onClick={() => {
              showConfirmationAlert(row.original.ID);
              // handleDelete(row.original.ID);
            }}
          >
            <Trash2 className='custome-icon-size' />
          </button>
        </Box>
      ),
    },
  ];

  const route = all_routes;

  const prodcutDataListApi = async () => {
    const response = await apiHandler({
      method: "GET",
      route: `Superadmin/SocialLinkMaster`,
    });
    if (response.ResponseCode === "SUCCESS") {
      console.log(response, "data");
      setProductlist(response.ResponseData);
    } else {
      console.log(response, "data");
    }
  };

  useEffect(() => {
    prodcutDataListApi();
  }, [deletes]);

  const exportData = productlist.map((item) => ({
    ID: item?.ID,
    Social: item?.name,
  }));

  return (
    <div className="page-wrapper">
      <div className="content">
        <HeaderModule
          refreshData={prodcutDataListApi}
          exportData={exportData}
          addMasterPageLink={route.SocialLinkMaster}
        />
        {/* /product list */}
        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-responsive">
              <CommonMaterialReactTable columns={columns} data={productlist} />
            </div>
          </div>
        </div>
        {/* /product list */}
        <Brand />
      </div>
    </div>
  );
};

export default SocialLinkList;
